import { render, staticRenderFns } from "./ColumnAccessStatus.vue?vue&type=template&id=4c74016e&scoped=true"
import script from "./ColumnAccessStatus.vue?vue&type=script&lang=js"
export * from "./ColumnAccessStatus.vue?vue&type=script&lang=js"
import style0 from "./ColumnAccessStatus.vue?vue&type=style&index=0&id=4c74016e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c74016e",
  null
  
)

export default component.exports